import { BorderStyle } from "../../../../base/styles";
import clsx from "clsx";

export const SelectBorderStyle = ({ title, value, className, onChange }: {
    title: string,
    value?: BorderStyle,
    className?: string,
    onChange: (value?: BorderStyle) => void,
}) => {
    const handleOnSelectionChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const newValue = e.target.value as BorderStyle;
        newValue ? onChange(newValue) : onChange(undefined);
    }

    return (
        <div className={clsx(className, "field-group mb-2")}>
            <label className="fs-8 fw-bold text-gray-600">{title}</label>
            <select
                onChange={handleOnSelectionChange}
                value={value || ""}
                className="form-select form-select-sm form-control-xs">
                <option></option>
                <option value={BorderStyle.Dashed}>Dashed</option>
                <option value={BorderStyle.Dotted}>Dotted</option>
            </select>
        </div>
    )
}